module.exports = __webpack_public_path__ + "static/media/classical-physics.d415d12e.svg";